module.exports = __webpack_public_path__ + "static/media/400058_02.3749a113.png";